import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Events } from "./events";
import { TasksAndFollows } from "./tasksandfollows";
import { Reminders } from "./reminders";
import { Breadcrumb } from "../../../../../components/breadcum";
import { CRMService } from "../../../../../app/core/crm.service";
import { FormatIndianDate } from "../../../../../app/utility/formatIndianDate";

export const CustomerTabs = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [customerData, setCustomerData] = useState<any>(null);
    const [customerList, setCustomerList] = useState<any>();

    const tabs = [
        { id: "1", title: "Tasks & Follows", route: "tasks-follows", content: <TasksAndFollows /> },
        { id: "2", title: "Reminders", route: "reminders", content: <Reminders /> },
        { id: "3", title: "Events", route: "events", content: <Events /> },
    ];
    const [activeTab, setActiveTab] = useState(tabs[0].id);

    useEffect(() => {
        const currentTab = tabs.find((tab) => tab.route === params?.route);
        if (currentTab) {
            setActiveTab(currentTab.id);
        }
    }, [params?.route]);

      useEffect(() => {
        getCustomers();
      }, []);
    
      const getCustomers = async () => {
        try {
            const payload={
                id:params.id
            }
          const res = await CRMService.GET_CUSTOMERS(payload);
          setCustomerList(res || {})
        }
        catch (err) {
        }
      }

    useEffect(() => {
        if (!params?.route) {
            navigate(`/dashboard/crm/vendors-list/${params.id}/${tabs[0].route}`);
        }
    }, [params, navigate]);

    const handleTabClick = (tabId: string) => {
        const selectedTab = tabs.find((tab) => tab.id === tabId);
        if (selectedTab) {
            setActiveTab(tabId);
            navigate(`/dashboard/crm/vendors-list/${params.id}/${selectedTab.route}`);
        }
    };

    const [breadcrumbInfo, setBreadcrumbInfo] = useState<any>([
        {
            label: "customer list",
            value: "customer list",
            routerLink: `/dashboard/crm/vendors-list`,
            isActive: false,
        },
        {
            label: `${params.id}`,
            value: `${params.id}`,
            routerLink: ``,
            isActive: true,
        },
    ]);

    return (
        <div className="container-fluid content-bg-color">
            <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
            <div className="row">
                <div className="col-md-3 border-end">
                    <div className="d-flex align-items">
                        <span
                            style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "22px",
                                fontWeight: "bold",
                            }}
                            className="bg-primary"
                        >
                            {customerList?.name?.charAt(0).toUpperCase() || 'c'}
                        </span>
                        <h5 className="ms-2 fw-bold mb-0">{customerList?.name}</h5>
                    </div>
                    <h6 className="fw-bold mb-0 mt-4">Shop Name</h6>
                    <div className="">{customerList?.shop_name}</div>

                    <h6 className="fw-bold mb-0 mt-4">Mobile Number</h6>
                    <div className="">{customerList?.contact}</div>

                    <h6 className="fw-bold mb-0 mt-4">Address</h6>
                    <div className="">{customerList?.address}</div>

                    <h6 className="fw-bold mb-0 mt-4">Created Date</h6>
                    <div className="">{FormatIndianDate(customerList?.created_date, "")}</div>

                </div>
                <div className="col-md-9">
                    <div className="overflow-auto no-vertical-scroll scroll-container">
                        <ul
                            className="nav nav-tabs flex-nowrap"
                            id="myTab"
                            role="tablist"
                            style={{ minWidth: 'max-content', whiteSpace: 'nowrap' }}
                        >
                            {tabs.map((tab) => (
                                <li className="nav-item" role="presentation" key={tab.id}>
                                    <button
                                        className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                                        id={`${tab.id}-tab`}
                                        onClick={() => handleTabClick(tab.id)}
                                        data-bs-toggle="tab"
                                        type="button"
                                        role="tab"
                                        aria-controls={tab.id}
                                        aria-selected={activeTab === tab.id}
                                    >
                                        {tab.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        {tabs.map((tab) => (
                            <div
                                className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""}`}
                                id={tab.id}
                                role="tabpanel"
                                aria-labelledby={`${tab.id}-tab`}
                                key={tab.id}
                            >
                                {activeTab === tab.id && tab.content}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
